'use client';

import { useParams, useRouter } from 'next/navigation';

import { Button } from '@/components/ui';
import { MustangArrow } from '@/components/ui/MustangArrow';
import { motion } from '@/libs';
import { ROUTES } from '@/types/enums';

type NoTicketsModalProps = {
  onClose: () => void;
  gameTitle?: string;
};

export const NoTicketsModal = ({
  onClose,
  gameTitle = 'ROLETA DE PRÊMIOS',
}: NoTicketsModalProps) => {
  const { push } = useRouter();
  const { id } = useParams<{ id: string }>();
  const handleGoToCheckout = () => {
    onClose();

    if (!id) {
      push(ROUTES.Enum[`/`]);
    }

    push(`/detalhes/${id}`);
  };

  return (
    <div
      className="w-full relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6 md:p-8 overflow-visible"
      style={{ boxShadow: '0 8px 30px rgba(2,6,23,0.6)' }}
      onClick={(e) => e.stopPropagation()}
    >
      <motion.div
        className="flex flex-col items-center gap-4 w-full relative z-20 mb-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <motion.h2
          className="text-3xl md:text-4xl font-semibold text-primary-foreground mb-2 uppercase text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          {gameTitle}
        </motion.h2>
        <motion.p
          className="text-base font-medium md:text-lg text-primary-foreground mb-2 uppercase text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          Não foi dessa vez..
        </motion.p>
        <motion.p
          className="text-sm text-primary-foreground/80 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.4 }}
        >
          Mas você ainda está concorrendo ao sorteio principal!
        </motion.p>
        <motion.p
          className="text-sm text-primary-foreground/80 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.4 }}
        >
          Quer mais chances de ganhar? 🤑💰 <br />
          Aproveite agora! ☘️
        </motion.p>
      </motion.div>

      <motion.div
        className="flex flex-col items-center gap-2 w-full relative z-20 mb-2"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      >
        <motion.div
          className="w-full"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.6 }}
        >
          <Button
            variant="secondary"
            onClick={handleGoToCheckout}
            className="w-full rounded-lg font-semibold h-10 text-sm"
          >
            Comprar Novamente
            <MustangArrow />
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
};
